import { JSX, use, useEffect, useRef, useState } from 'react';
import Menu from './menu/menu';
import TodoPreview from './preview/todoPreview';
import NotePreview from './preview/notePreview';
import ClockWeatherPreview from './preview/clockWeatherPreview';
import Loading from '../common/Loading/loading';
import './homePage.css'
import EventPreview from './preview/eventPreview';

export type homePageButton = 'Add' | 'Todo' |'Note' | 'Calendar';

export interface HomepageProps {
  clickButton: homePageButton | null,
  onClickButtonChange: (button: homePageButton) => void;
}

const HomePage = ({clickButton, onClickButtonChange}:HomepageProps): JSX.Element => {
    const [isTodoPreviewLoading, setIsTodoPreviewLoading] = useState(true);
    const [isNotePreviewLoading, setIsNotePreviewLoading] = useState(true);
    const [isEventPreviewLoading, setIsEventPreviewLoading] = useState(true);
    const [availableHeight, setAvailableHeight] = useState(0);
    const todoSectionRef = useRef(null);
    const noteSectionRef = useRef(null);

    const handleTodoPreviewLoading = (loading: boolean) => {
      setIsTodoPreviewLoading(loading);
    }
    const handleNotePreviewLoading = (loading: boolean) => {
      setIsNotePreviewLoading(loading);
    }

    const handleEventPreviewLoading = (loading: boolean) => {
      setIsEventPreviewLoading(loading);
    }

    useEffect(() => {
      const calculateHeight = () => {
        const topHeight = todoSectionRef.current?.getBoundingClientRect().top;
        console.log(`todo ref: ${topHeight}`)
        const topHeight_note = noteSectionRef.current?.getBoundingClientRect().top;
        console.log(`note ref: ${topHeight_note}`)
        const height = window.innerHeight * 0.97 - topHeight - 40;
        console.log(`window height: ${window.innerHeight}`)
        console.log(`height: ${height}`)
        setAvailableHeight(height);
      };
      
      const timeoutId = setTimeout(() => {
        calculateHeight();
      }, 100); 

      window.addEventListener('resize', calculateHeight);
      return () => {
        window.removeEventListener('resize', calculateHeight);
        clearTimeout(timeoutId);
      };
    }, []);

    return (
      <div>
        <Menu clickButton={clickButton} onClickButtonChange={onClickButtonChange}/>
        <div className='preview-container'>
          <div className='clock-weather-preview-container'>
            <ClockWeatherPreview/>
          </div>
          <EventPreview setLoading={(loading: boolean) => handleEventPreviewLoading(loading)}/>
          <TodoPreview topRef={todoSectionRef} setLoading={(loading: boolean) => handleTodoPreviewLoading(loading)} maxHeight={availableHeight * 0.5}/>
          <NotePreview topRef={noteSectionRef} setLoading={(loading: boolean) => handleNotePreviewLoading(loading)} maxHeight={availableHeight * 0.5}/>
        </div>
        {(isTodoPreviewLoading || isNotePreviewLoading || isEventPreviewLoading) && <Loading/>}
      </div>
    ); 
  };
  
  export default HomePage;